// Shared chat rendering components
export { ChatMessage } from './ChatMessage'
export { ChatMessageList } from './ChatMessageList'
export { ChatInput } from './ChatInput'
export { ThinkingIndicator } from './ThinkingIndicator'
export { MessageActions } from './MessageActions'

// Block components
export { TextBlock } from './blocks/TextBlock'
export { CodeBlock } from './blocks/CodeBlock'
export { VisualizationBlock } from './blocks/VisualizationBlock'
export { InteractiveElementsBlock } from './blocks/InteractiveElementsBlock'

// Types
export type {
  ContentBlock,
  TextContentBlock,
  VisualizationContentBlock,
  InteractiveElementsContentBlock,
  ActionButtonContentBlock,
  ChatMessageData,
  MessageStatus,
  MessageError,
  MessageProgress,
  ToolExecution,
  ChatMessageListProps,
  ChatMessageProps,
  ChatInputProps,
} from './types'

// Visualization system
export { SVSRenderer } from './visualizations/SVSRenderer'
export type { SVSPayload, SVSType } from './visualizations/svs-types'

// Utilities
export {
  containsMarkdown,
  parseContentToBlocks,
  buildChatMessage,
  appendToMessage,
  formatDuration,
  generateMessageId,
} from './utils'
